var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5C9 5.55228 8.55229 6 8 6C7.44772 6 7 5.55228 7 5C7 4.44772 7.44772 4 8 4C8.55229 4 9 4.44772 9 5ZM9 12L7 12L7 7L9 7L9 12ZM8.008 16C12.424 16 16 12.416 16 8C16 3.584 12.424 6.41051e-07 8.008 2.54992e-07C3.584 -1.31767e-07 1.08544e-06 3.584 6.99382e-07 8C3.13323e-07 12.416 3.584 16 8.008 16ZM8 2C11.536 2 14 4.464 14 8C14 11.536 11.536 14 8 14C4.464 14 2 11.536 2 8C2 4.464 4.464 2 8 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.db9380c7a3380b09a3aaa4ec08f66ceb.svg";
export { ForwardRef as ReactComponent };